var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-add"},[_c('div',{staticClass:"add-title"},[_vm._v("新增用户")]),_c('basic-form',{ref:"basic",on:{"addUser":_vm.addUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }